import { render, staticRenderFns } from "./UpdateClientCompany.vue?vue&type=template&id=768e65f2&"
import script from "./UpdateClientCompany.vue?vue&type=script&lang=js&"
export * from "./UpdateClientCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports